import React from "react";
import "./subnavigation.scss"

const SubNavigation = (props) => {     
    return (
        <div id={"subNavigation"}>
            <div class={"subNavigationContent"}>
                <ul>
                    { props.data.items.map(item => (
                        <li><a href={item.href}>{item.text}</a></li>
                    ))}
                </ul>
                { props.data.buttonText != undefined && props.data.buttonHref != undefined ?
                    <div className={"buttonContainer"}>
                        {/*<a className={"btn btn-link pink"} href={props.data.buttonHref}>{props.data.buttonText}</a>*/}
                    </div>
                    : ""
                }
            </div>
        </div>
    )
}

export default SubNavigation;